import { cn } from '../../lib/utils';

const variants = {
  primary:
    'bg-brand text-ink-950 hover:bg-brand-400 shadow-brand hover:shadow-brand-lg',
  secondary:
    'bg-white/[0.06] text-white border border-line-strong hover:bg-white/[0.12] hover:border-white/25',
  outline:
    'bg-transparent text-white border border-line-strong hover:bg-white/[0.06]',
  ghost:
    'bg-transparent text-content-muted hover:text-white hover:bg-white/[0.06]',
  whatsapp:
    'bg-[#25D366] text-ink-950 hover:bg-[#1FBB59] shadow-card',
};

const sizes = {
  sm: 'h-9 px-4 text-sm gap-1.5',
  md: 'h-11 px-6 text-[0.9375rem] gap-2',
  lg: 'h-13 px-8 text-base gap-2.5 py-3.5',
};

/**
 * The single button primitive for the site.
 *
 * Renders a <button> by default, or an <a> when `href` is passed, so link-CTAs
 * keep correct semantics (right-click, open-in-new-tab, keyboard) instead of
 * being buttons that call window.location.
 */
export default function Button({
  as,
  variant = 'primary',
  size = 'md',
  className,
  href,
  fullWidth = false,
  children,
  ...props
}) {
  const Component = as ?? (href ? 'a' : 'button');

  return (
    <Component
      href={href}
      className={cn(
        'inline-flex items-center justify-center rounded-full font-semibold whitespace-nowrap',
        'transition-[background-color,border-color,box-shadow,transform] duration-200 ease-smooth',
        'hover:-translate-y-0.5 active:translate-y-0 active:scale-[0.98]',
        'disabled:pointer-events-none disabled:opacity-50',
        variants[variant],
        sizes[size],
        fullWidth && 'w-full',
        className,
      )}
      {...(Component === 'button' && !props.type ? { type: 'button' } : null)}
      {...props}
    >
      {children}
    </Component>
  );
}
